function install (Vue) {
  /**
   * Helper function to log all queries run
   * @param {String} title dashboard title
   * @param {String} queryId query ID from snowflake
   * @param {String} query query content
   * @param {String} name table name for the associated query
   */
  Vue.prototype.$dashboardQueryLog = (title, queryId, query, name) => {
    Vue.prototype.$log('query_run', title, { queryId, query, name })
  }

  Vue.prototype.$customDashboardOpenLog = (title, loadTime) => {
    Vue.prototype.$log('report_open', title, { loadTime })
  }
}

export default { install }
